jQuery(function ($) {
  var $loginMessage = $( "#wpmem_msg" );

  $( "#wpmem_login" ).removeAttr( "id" );
  $( "#wpmem_login_form" ).addClass( "form-container form-login" );
  $loginMessage.addClass( "well well-blank-shadow" );
  $loginMessage.children("h2").addClass("title-text-dark-blue");

  var $formLoginInput = $(".form-login input");

  $formLoginInput.filter(".buttons").addClass( "btn btn-block btn-bg-dark-blue" );
  $formLoginInput.filter(".username").before( "<label for='log'>メールアドレス</label>" );
  $formLoginInput.filter(".password").before( "<label for='password'>パスワード</label>" );
});
